module.exports = __webpack_public_path__ + "static/Feature-1-68e15c7a7b1c5172823984699bb9fa32.svg";